import { render } from "./ClubLocation.vue?vue&type=template&id=c20a966e"
import script from "./ClubLocation.vue?vue&type=script&lang=js"
export * from "./ClubLocation.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__